import React, { useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

import { Container, Row, Col } from "..//Grid"
import Button from "..//Button"
import Snippet from "../Snippet"
import YouTubePlayer from "../YouTubePlayer"
import Waypoint from "../Waypoint"
import Lightbox from "../Lightbox"

import { media, mixins } from "../../styles"

const Wrapper = styled.div`
  h2 {
    ${mixins.title3}
    text-align: center;

    @media ${media.md} {
      text-align: left;
    }
  }

  p {
    ${mixins.copy4}
  }

  .button {
    margin-top: 20px;
  }
`

const VideoThumbnail = styled.div`
  aspect-ratio: 1144 / 786;
  background-color: var(--color-greyWarm);
  cursor: pointer;
  margin: 0 auto 30px;
  max-width: 572px;
  position: relative;

  &:focus-visible {
    outline-color: var(--color-sun);
    outline-offset: 5px;
  }

  object,
  svg {
    cursor: pointer;
    display: block;
    height: 100%;
    height: auto;
    position: relative;
    width: 100%;
    z-index: 0;
  }

  @media ${media.md} {
    margin: 0 auto;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

const Placeholder = () => (
  <svg width="1144" height="786" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#E8E2E1" width="1144" height="786" fillRule="evenodd" />
  </svg>
)

const Video = () => {
  const [showDialog, setShowDialog] = useState(false)
  const [showAnimation, setShowAnimation] = useState(false)
  const intl = useIntl()

  const openLightbox = (e) => {
    e.preventDefault()
    setShowDialog(true)
  }
  const closeLightbox = () => setShowDialog(false)

  return (
    <>
      <VideoThumbnail
        onClick={(e) => openLightbox(e)}
        aria-label="Animation"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            openLightbox(e)
          }
        }}
      >
        <Waypoint
          onEnter={() => setShowAnimation(true)}
          threshold={0.6}
          aria-hidden={true}
        >
          <Overlay />
          {showAnimation &&
            (intl.locale === "de" ? (
              <object
                aria-hidden={true}
                aria-label="Animation"
                data={
                  "/assets/animations/video-about-solaris-autoplay-css-de.svg"
                }
                tabIndex="-1"
                type="image/svg+xml"
              />
            ) : (
              <object
                aria-hidden={true}
                aria-label="Animation"
                data={
                  "/assets/animations/video-about-solaris-autoplay-css-en.svg"
                }
                tabIndex="-1"
                type="image/svg+xml"
              />
            ))}
        </Waypoint>
      </VideoThumbnail>
      <Lightbox show={showDialog} close={closeLightbox} ariaLabel={"Video"}>
        <YouTubePlayer
          url={Snippet({ id: "homeAboutVideo", field: "linkUrl" })}
          autoplay={true}
          isPlaying={true}
          thumbnail={<Placeholder />}
        />
      </Lightbox>
    </>
  )
}

const About = () => {
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col md="6">
            <Video />
          </Col>
          <Col md="6" lg="5">
            <h2>
              <Snippet id="homeAbout" field="header" />
            </h2>
            <Snippet id="homeAbout" field="text" md />
            <Button
              to={Snippet({ id: "homeAbout", field: "linkUrl" })}
              as={Link}
              arrow
              className="button"
            >
              {Snippet({ id: "homeAbout", field: "linkText" })}
            </Button>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default About
